import { addEvent, cancelBubble, removeEvent } from '../utils/events';

export class Accordion {

  /**
   * @param  {Dom}    accordion         container to hold accordion
   * @param  {Bool}   openByDefault     open first item onLoad
   */
  constructor(accordion, config) {
    this.accordion = accordion;
    this.openByDefault = config.openByDefault;
    this.singleOpen = config.singleOpen;

    if (!this.isEverythingOk()) {
      return;
    }

    // this.accordionItems = this.accordion.querySelectorAll('.accordion__item');
    this.accordionItems = this.accordion.children;

    // Bind the context with the event
    this.showItem = this.showItem.bind(this);

    // Initialize accordion
    this.init();
  }

  init() {
    for (const accordionItem of this.accordionItems) {
      if (accordionItem.classList.contains('accordion__item')) {
        addEvent(accordionItem.querySelector('.accordion__title'), 'click', this.showItem);
      }
    }
    if (this.openByDefault) {
      this.accordionItems[0].classList.add('accordion--open');
    }
  }

  destroy() {
    for (const accordionItem of this.accordionItems) {
      removeEvent(accordionItem.querySelector('.accordion__title'), 'click', this.showItem);
    }
  }

  showItem(evt) {
    cancelBubble(evt);
    const parentItem = evt.currentTarget.parentNode;
    if (this.singleOpen === true) {
      if (parentItem.classList.contains('accordion--open')) {
        parentItem.classList.remove('accordion--open');
      } else {
        for (const accordionItem of this.accordionItems) {
          accordionItem.classList.remove('accordion--open');
        }
        parentItem.classList.add('accordion--open');
      }
    } else {
      parentItem.classList.toggle('accordion--open');
    }
  }

  /* eslint-disable no-console */
  isEverythingOk() {
    if (!this.accordion) {
      console.warn('CommonUI - Accordion - There\'s no accordion found');
      return false;
    } else if (this.accordion.querySelectorAll('.accordion__item').length === 0) {
      console.warn('CommonUI - Accordion - There\'s no accordion items found');
      return false;
    }
    return true;
  }
  /* eslint-enable no-console */
}

/**
 * Creates a new accordion instance
 * @param  {Object} config
 */
export default function initAccordion({
  selector = '.js-accordion',
  openByDefault = true,
  singleOpen = true,
} = {}) {
  let accordions = null;
  if (typeof selector === 'string') {
    for (const accordion of document.querySelectorAll(selector)) {
      accordions = new Accordion(accordion, { openByDefault, singleOpen });
    }
  }
  return accordions;
}



// WEBPACK FOOTER //
// ./js/components/Accordion.js